import { parse } from '../request';
import { Resource } from './resource';
import { Role } from './role';
import { ACL } from './acl';

const parseRuleDefinition = (value, granted) => {
    if (typeof value === 'object') {
        const { rule, ...payload } = value;
        const parsed = parseRuleDefinition(rule, granted);

        parsed.payload = payload;

        return parsed;
    }

    const { resource, actions } = parse(value);

    return new Resource(
        resource,
        actions.reduce((acc, action) => ((acc[action] = granted), acc), {})
    );
};

export const loadACL = (definitions) => {
    const acl = new ACL();

    for (const { id, rules } of definitions) {
        const { extend, grant, reject } = rules;
        const parent = extend && acl.getRole(extend);
        const role = acl.addRole(new Role(id, parent));

        for (const [rules, granted] of [[grant, true], [reject, false]]) {
            if (rules) {
                for (const rule of rules) {
                    role.addResource(parseRuleDefinition(rule, granted));
                }
            }
        }
    }

    return acl;
};
